// A lichen-covered rock: a low grey boulder with a few pale green-grey lichen
// patches clinging to it. Ported 1:1 from age-of-mcp's classic lichen-rock.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.3, 0),
      color: "#7c7f86", position: [0, 0.2, 0], scale: [1.2, 0.8, 1.1] },
    { geometry: new THREE.IcosahedronGeometry(0.16, 0),
      color: "#6e7178", position: [0.18, 0.12, 0.1] },
    // lichen patches
    { geometry: new THREE.IcosahedronGeometry(0.1, 0),
      color: "#9aa884", position: [-0.1, 0.3, 0.12], scale: [1, 0.4, 1] },
    { geometry: new THREE.IcosahedronGeometry(0.08, 0),
      color: "#aebf95", position: [0.12, 0.28, -0.08], scale: [1, 0.4, 1] },
  ];
}

export const lichenRock = defineModel({
  id: "lichen-rock",
  batchId: "standard",
  name: "Lichen rock",
  tags: ["scenery","lichen","rock","low-poly","age-of-mcp","classic"],
  summary: "Low-poly lichen rock.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => partsFor(),
  animations: [],
});
